import { uniqueId } from 'lodash-es'

const ID_PREFIX = 'SHJ_CS_FLOAT_PANEL'
import bg from '../assets/cs_float_bg@2x.png'
import hangupIcon from '../assets/hangup.png'
import boxBg from '../assets/content_box.png'
import { setStyle } from '@/components/shj-soft-phone/utils.ts'
// import './index.less'
// import css from './index.css'
import panelCss from './style.js'

// console.log('css', css)
let isAppendStyle = false

function styleInject(css: string) {
  if (!css || typeof document === 'undefined') {
    return
  }
  var head = document.head || document.getElementsByTagName('head')[0]
  var style: any = document.createElement('style')

  style.type = 'text/css'
  style.id = 'shj_cc_float_panel'
  // style.global = true
  // style.rel = 'stylesheet'
  // style.id = 'float_panel_style'
  // style.innerText = css
  // head.appendChild(style)

  head.appendChild(style)
  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
}

export class FloatPanel {
  isInit = false
  createElement: (tag: string) => HTMLDivElement
  root?: HTMLDivElement | null = null
  id?: string
  events?: any
  position?: any
  showTimer?: any // 展示通话时间延时

  state = {
    panelVisible: false,
    stateTimer: '00:00:00',
    seatStateText: '',
    callPhone: '',
    panelShowData: [] as any[],
    panelTimerVisible: false,
    size: 'normal',
    detail: null as any,
  }

  constructor(props?) {
    this.createElement = props?.createElement || document.createElement
    this.id = uniqueId(ID_PREFIX)
  }

  bindCreateElement(createElement) {
    this.createElement = createElement
  }

  init() {
    // <link rel="stylesheet" href="https://static.shjmall.cn/soft_phone/float_panel.css" global>
    try {
      this!.root = document.createElement('div')
      this!.root!.id = this.id || uniqueId(ID_PREFIX)
      this!.root!.className = 'shj-cs-float-panel'
      setStyle(this.root, {
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
      })

      this.render()
      document.body.appendChild(this.root)
      if (!isAppendStyle) {
        // const cssLink: any = this.createElement('link')
        // cssLink.rel = 'stylesheet'
        // cssLink.href = 'https://static.shjmall.cn/soft_phone/float_panel.css'
        // cssLink.global = true
        // document.head.appendChild(cssLink)
        styleInject(panelCss)
        isAppendStyle = true
      }

      // 绑定盒子拖动事件
      this.root?.removeEventListener('mousedown', this.handleMouseDown)
      this.root?.addEventListener?.('mousedown', this.handleMouseDown)

      // document.addEventListener('SOFT_FLOAT_DESTROY', this.destroy)
      this._delegateEvent()
    } catch (err) {
      console.log(err)
    }
  }

  bindEvent(events: any) {
    this.events = events
  }

  handleMouseDown = e => {
    // console.log(e)
    if (this.root) {
      let position = {
        disX: e.clientX - this.root.offsetLeft,
        disY: e.clientY - this.root.offsetTop,
        x: this.root.offsetLeft,
        y: this.root.offsetTop,
      }
      this.position = position
      this.root.style.right = 'auto'
      this.root.style.bottom = 'auto'
      this.root.style.left = position.x + 'px'
      this.root.style.top = position.y + 'px'
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
    }
  }

  handleMouseMove = e => {
    if (this.root) {
      const {
        disX,
        disY,
        // x, y
      } = this.position
      e.preventDefault()
      let left = e.clientX - disX
      let top = e.clientY - disY

      if (left < 0) {
        left = 0
      }
      if (top < 0) {
        top = 0
      }

      if (left + this.root.offsetWidth > window.innerWidth) {
        left = window.innerWidth - this.root.offsetWidth
      }

      if (top + this.root.offsetHeight > window.innerHeight) {
        top = window.innerHeight - this.root.offsetHeight
      }

      this.root.style.left = left + 'px'
      this.root.style.top = top + 'px'
    }
  }

  handleMouseUp = () => {
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  }

  _delegateEvent() {
    // console.log('root _delegateEvent', this.root)
    this.root?.removeEventListener('click', this.delegateClick)
    this.root?.addEventListener?.('click', this.delegateClick)
  }

  matchEvent(event, hookName) {
    return event.target.classList?.contains?.(hookName)
  }

  delegateClick = event => {
    // console.log('event', event)
    if (this.matchEvent(event, 'hangUpHook')) {
      // console.log('hangUpHook click')
      this.events?.hangUp?.()
    } else if (this.matchEvent(event, 'toggleSizeHook')) {
      this.toggleSize()
    } else if (this.matchEvent(event, 'linkHook')) {
      this.linkTo()
    }
    // console.log('click', event)
  }

  toggleSize() {
    this.state.size = this.isSmall() ? 'normal' : 'small'
    if (this.state.size === 'small') {
      this.root?.querySelector('.sizeHook')?.classList?.add?.('small')
    } else {
      this.root?.querySelector('.sizeHook')?.classList?.remove?.('small')
    }
    this.renderInfo()
    this.renderHangUp()
  }

  linkTo() {
    this.events.onLink?.({ key: this.state.detail?.id })
  }

  setState = (nextState = {}) => {
    for (let key in nextState) {
      this.state[key] = nextState[key]
    }
    this.render()
  }

  updateTimer(stateTimer) {
    this.state.stateTimer = stateTimer
    this.renderTimerCount()
  }

  updatePanelData(data) {
    console.log('updatePanelData', data)
    this.state.panelShowData = [
      {
        label: '姓名',
        value: data.clueName,
        link: true,
      },
      {
        label: '线索ID',
        value: data.id,
      },
      {
        label: '渠道',
        value: data.channel,
      },
    ]
    this.renderInfo()
  }

  setPanelShowData(showData: any[]) {
    this.state.panelShowData = showData
    this.renderInfo()
  }

  resetPanelData() {
    this.state.panelShowData = []
  }

  updateDetail(detailData) {
    // console.log(detailData)
    this.state.detail = detailData
  }

  showPanelTimer() {
    this.state.panelTimerVisible = true
    this.renderTimerCount()
  }

  switchTalkingState() {
    this.showPanelTimer()
  }

  show() {
    this.state.panelVisible = true
    if (!this.root) {
      this.init()
    }
    this.root!.style!.display = 'block'
  }

  destroy() {
    console.log('float panel destroy')
    this.close()
    // this.root!.style!.display = 'none'
    this.root?.remove?.()
    this.root = null
    // document.removeEventListener('SOFT_FLOAT_DESTROY', this.destroy)
  }

  close() {
    if (this.root) {
      this.root.style.display = 'none'
    }
  }

  isSmall = () => {
    return this.state.size === 'small'
  }
  renderTimerCount = () => {
    const { panelTimerVisible, size, seatStateText, stateTimer } = this.state
    const id = `shj_float_timer_${size}`
    const isSmall = this.isSmall()
    const timerEl = this.root?.querySelector?.(`#${id}`)

    let timerContent = ''
    if (isSmall && panelTimerVisible) {
      timerContent = `<div class="timeCountSmallText">${stateTimer || ''}</div>`
    } else if (isSmall) {
      timerContent = `<div class="statusSmallText">${seatStateText || ''}</div>`
    } else if (panelTimerVisible) {
      timerContent = `<div class="shj-float-panel-time-count-text">${stateTimer || ''}</div>`
    } else {
      timerContent = `<div class="shj-float-panel-status-text">${seatStateText || 'werwer'}</div>`
    }

    if (timerEl) {
      timerEl.innerHTML = timerContent
    }

    return `<div id="${id}">
        ${timerContent}
      </div>`
  }

  renderInfo() {
    const id = 'shj_float_panel_info'
    const { panelShowData, callPhone } = this.state
    const isSmall = this.isSmall()
    let infoHtmlStr: string | null = null
    if (isSmall) {
      const smallInfoData = panelShowData
        ?.filter?.((d: any) => !!d.link)
        .map?.((d: any) => {
          return `<div class="infoSmallItem linkHook" >
            <div class="infoSmallText textRight textOverflow">${d.value || ''}</div>
            <div class="arrowRight"></div>
        </div>`
        })

      infoHtmlStr = `<div class="infoSmall">
           ${smallInfoData?.join('')}
           ${this.renderTimerCount()}
      </div>`
    } else {
      const infoData =
        panelShowData?.map?.((d: any) => {
          const linkRow = `<div class="infoRow" >
            <div class="text">${d.label || ''}</div>
              <div class="jumpTo linkHook">
            <div class="text textRight textOverflow">${d.value || ''}</div>
            <div class="arrowRight"></div>
              </div>
          </div>`
          const row = `<div class="infoRow" >
            <div class="text label">${d.label || ''}</div>
            <div class="text textRight textOverflow">${d.value || ''}</div>
          </div>`
          return d.link ? linkRow : row
        }) || []

      const infoWrap = `<div class="infoWrap" style="background-image: url(${boxBg})">
        ${
          panelShowData?.length
            ? infoData.join('')
            : `<div class="infoRow">
                    <div class="text">未知</div>
                    <div class="text textRight">${callPhone || ''}</div>
                </div>`
        }
        </div>`
      infoHtmlStr = `<div class="info-normal">
        ${this.renderTimerCount()}
        ${infoWrap}
      </div>`
    }

    const infoEl = this.root?.querySelector(`#${id}`)

    if (infoEl) {
      infoEl.innerHTML = infoHtmlStr
    }

    return `<div id="${id}">
        ${infoHtmlStr}
      </div>`
  }

  renderHangUp = () => {
    const id = 'shj_float_hang_up'
    const hangUpBtn = this.isSmall()
      ? `<div class="hangupTextIcon" style="background-image:url(${hangupIcon})"></div>`
      : `<div class="hangupText">挂断</div>`

    const el = this.root?.querySelector(`#${id}`)

    if (el) {
      el.innerHTML = hangUpBtn
    }

    return `<div id="${id}" class="hangupIcon hangUpHook">${hangUpBtn}</div>`
  }

  render() {
    if (!this.root) return
    const isSmall = this.isSmall()
    const content = `
      <div
          id="shj_float_panel_content" 
          class="shj-float-panel-content-wrap ${isSmall ? 'small' : ''} sizeHook"
      >
          <div 
            class="shj-float-panel-content" 
            style="background-image: url(${bg})"
          >
              <div 
                class="shj-content-size-toggle ${isSmall ? 'small' : ''} sizeHook toggleSizeHook"  
              ></div>
              
              ${this.renderInfo()}
  
              ${this.renderHangUp()}
          </div>
      </div>`

    if (this.root?.querySelector('#shj_float_panel_content')) {
      this.renderInfo()
      this.renderHangUp()
    } else {
      this.root!.innerHTML = content
    }
  }
}

export default new FloatPanel()
